import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Application } from '../../models/application.model';
import { HttpClient } from '@angular/common/http';
import { RestEndpoint } from '../../../constants/rest-endpoint.constants';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ApplicationService {

    constructor(
        private readonly http: HttpClient,
    ) {
    }

    public getApplications(): Observable<Array<Application>> {
        return this.http.get(RestEndpoint.getAllapplications, {})
            .pipe(
                map((data: Array<Application>) => {
                    return data;
                }),
                catchError((err) => {
                    throw(err);
                })
        );
    }

    public getDocumentationLink(): Observable<any> {
        return this.http.get(RestEndpoint.documentationLink, {})
            .pipe(
                map((data: any) => {
                    return data;
                }),
                catchError((err) => {
                    throw(err);
                })
        );
    }

    public deleteApplication(id: string): Observable<boolean> {
        const url = RestEndpoint.deleteApplication + id;
        return this.http.delete<boolean>(url)
            .pipe(
                catchError((err) => {
                    throw err;

                })
            );
    }

    public getApplication(applicationIdentifier: string): Observable<Application> {
        return this.http.get(RestEndpoint.readDetails, {params: {applicationIdentifier}})
            .pipe(
                map((data: Application) => {
                    return data;
                }),
                catchError((err) => {
                    throw(err);
                })
        );
    }

    public updateApplication(newPlaceholder: Application): Observable<boolean> {
        return this.http.put<boolean>(RestEndpoint.updateApplication, newPlaceholder)
            .pipe(
                map((updated: boolean) => {
                    return updated;
                }),
                catchError((err) => {
                    throw err;

                })
            );    
    }

    public createApplication(placeHolder: Application): Observable<boolean> {
        return this.http.post<string>(RestEndpoint.createApplication, placeHolder)
            .pipe(
                map((templateId: string) => {
                    if(templateId) {
                        return true;
                    } else {
                        return false;
                    }
                }),
                catchError((err) => {
                    throw err;

                })
            );
    }
}